<template>
  <div class="footer" :class="{'footer--white': white, 'footer--floating-visible': floatingFooterVisible}">
    <p>Beautynet Ltd</p>
    <p>Newminster House, 27-29 Baldwin St, Bristol, United Kingdom, BS1 1LT</p>
    <p class="footer-text--big">
      © {{ new Date().getFullYear() }} Beautynet Limited | VAT Number GB934762110000 | <privacy-policy-modal/> | <cookies-modal/>
    </p>
    <p class="footer-text--small">
      © {{ new Date().getFullYear() }} Beautynet Limited | VAT Number GB934762110000
    </p>
    <p class="footer-text--small">
      <privacy-policy-modal/> | <cookies-modal/>
    </p>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import { path } from 'ramda'
import PrivacyPolicyModal from '../Utils/PrivacyPolicyModal'
import CookiesModal from '../Utils/CookiesModal'

export default {
  name: 'AppFooter',
  components: { CookiesModal, PrivacyPolicyModal },
  props: {
    white: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(
      {
        floatingFooterVisible: path(['floatingFooterVisible']),
      },
    ),
  },
}
</script>
